import React, { useState } from "react";
import { Upload, Button, message, Form } from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat";
import Hexapi from "../../utility/HexAPI/Hexapi";
import mammoth from "mammoth";
import { showConfirm } from "../../utility/showconfirm";
dayjs.extend(customParseFormat);

const MODEL_ID = "gemini-2.5-flash-lite";
const INR_RATE = 84;
const INPUT_PRICE_PER_1M = 0.075 * INR_RATE;
const OUTPUT_PRICE_PER_1M = 0.30 * INR_RATE;



const normalize = (v) =>
  String(v || "").trim().toLowerCase();

const findMasterId = (list = [], label, labelKeys = []) => {
  const item = list.find((x) =>
    labelKeys.some((key) => normalize(x[key]) === normalize(label))
  );

  return  item?.recid || null;
};
export default function ResumeUploadParser({
  form,
  setSkills,
  resumeFile,
  setResumeFile,
  isresume,
  formData,
  agentID,
  setresumerequired,
  setResumeUploading,
  setresumedataai
}) {
const qualificationNames =
  formData?.qualification?.map((q) =>
     q.name || q.label
  ) || [];
const experienceList = formData?.experience?.map((e) => ({
  recid: e.recid,
  label: e.ExperienceLabel
})) || [];
const PROMPT = `You are a resume parser. Extract information from the provided document and return ONLY a valid JSON object with no extra text, no markdown, no code blocks.
qualificationlist: ${JSON.stringify(qualificationNames)}
experiencelist: ${JSON.stringify(experienceList)}

Document Processing Rules:
- ONLY accept and process Resumes and CVs.
- If the provided document is an Invoice, Receipt, PAN Card, Aadhaar Card, or ANY other non-resume document, you MUST reject it.
- If rejected, return exactly this JSON and nothing else: { "error": "Invalid document type. Only Resumes and CVs are accepted." }

If the document IS a Resume/CV, extract the following fields exactly:

{
  "personal": {
    "full_name": "string or null",
    "date_of_birth": "YYYY-MM-DD or null",
    "gender": "Male | Female | Other | null",
    "nationality": "string or null",
    "current_address": "string or null"
  },
  "contact": {
    "email_id": "string or null",
    "linkedin_profile": "string or null",
    "contact_number": "string or null",
    "country_code": "string e.g. '+91' or null",
    "alternate_number": "string or null",
    "alternatecountry_code": "string e.g. '+91' or null"
  },
  "professional": {
    "current_last_company": "string or null",
    "total_experience": "integer recid from experiencelist or null",
    "notice_period": "string e.g. '30 days' or null"
  },
  "education": {
    "highest_qualification": "exact value from qualificationlist or null",
    "specialisation_stream": "string e.g. 'Computer Science' or null",
    "institute_university": "string or null",
    "passing_year": "YYYY or null"
  },
  "skills": ["skill1", "skill2"]
}

Rules:
Experience Mapping Rules:
- experiencelist contains objects with recid and label.
- Match the candidate's experience against experiencelist.
- Return ONLY the corresponding recid as experience_id.
- experience_id must always be an integer.
- Never return the experience label or a string.

Qualification Mapping Rules:
- education.highest_qualification must be selected from qualificationlist.
- First look for an exact match. If none, return the closest match.
- Never invent a qualification not present in qualificationlist.
- If no reasonable match exists, return null.

General Parsing Rules:
- Return ONLY the JSON. No explanation, no markdown.
- If a field is not found, use null.
- For skills, return a flat array of strings with NO duplicates.
- For CTC, return numeric value only (e.g. 8.5).
- For date_of_birth, always return date in YYYY-MM-DD format. Convert formats like DD/MM/YYYY automatically.
- Extract country code separately from phone numbers (default to "+91" if missing).
- contact_number and alternate_number should contain digits only without country code.
- Infer gender from the candidate's name if not explicitly mentioned.
- For total_experience: Calculate the total work experience in years by adding up all job durations. Return as a simple string. Do NOT return null if work experience exists.
`;
  const [loading, setLoading] = useState(false);
const aiconfig=formData?.aiconfig
  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result.split(",")[1]);
      };

      reader.onerror = reject;
    });
  };

  const cleanJSON = (raw) => {
    let text = raw.trim();

    if (text.startsWith("```json")) {
      text = text.slice(7);
    } else if (text.startsWith("```")) {
      text = text.slice(3);
    }

    if (text.endsWith("```")) {
      text = text.slice(0, -3);
    }

    return text.trim();
  };
const extractYears = (text) => {
  const match = String(text || "").match(/\d+/);
  return match ? parseInt(match[0]) : null;
};

const findExperienceId = (list = [], value) => {
  const years = extractYears(value);

  if (!years) return null;

  const found = list.find((item) => {
    const label =
      item.ExperienceLabel ||
      item.label ||
      item["$Experience#Experience"] ||
      "";

    const rangeMatch = label.match(/(\d+)\s*-\s*(\d+)/);

    if (rangeMatch) {
      const min = parseInt(rangeMatch[1]);
      const max = parseInt(rangeMatch[2]);

      return years >= min && years <= max;
    }

    const singleMatch = label.match(/(\d+)/);

    if (singleMatch) {
      return years === parseInt(singleMatch[1]);
    }

    return false;
  });

  return found?.recid || found?.recid || null;
};

const Logsubmit=async(InputTokens,OutputTokens,totaltime,Answer,imageTokens)=>{
  const stats=`in-${InputTokens}out-${OutputTokens}-Totalthinkingtime-${totaltime}`
try {
  const obj={
    query:`[dbo].[HCMS_Proc_OCR_Log_Submit]
    @AgentID='{0}',
    @ModalName='{1}',
    @InputTokens='{2}',
    @OutputTokens='{3}',
    @Stats='{4}',
    @Answer='{5}',
    @targetedFor='{6}',
    @Imagetokens='{7}'
    `,
    queryArr:[`${agentID}`,`${MODEL_ID}`,`${InputTokens}`,`${OutputTokens}`,`${stats}`,`${Answer}`,"Resume Parsing",imageTokens]
  }
  
  const resp = await Hexapi(obj)
} catch (error) {
  console.log("Logging failed", error);
}
}
  const extractResumeData = async (file) => {
      setResumeUploading(true);
    try {
        let inputTokens = 0; 
   let outputTokens = 0; 
   let imageTokens = 0;

    let finalText = "";
    const startTime = Date.now();
      setLoading(true);
    const mimeType = file.type || "";
const isWordFile =
  mimeType.includes("word") ||
  file.name.endsWith(".doc") ||
  file.name.endsWith(".docx");


let messageParts = [];

if (isWordFile) {
  const arrayBuffer = await file.arrayBuffer();
  const result = await mammoth.extractRawText({ arrayBuffer });
  const resumeText = result.value;
  if (!resumeText?.trim()) throw new Error("Word file se text extract nahi ho saka.");
  messageParts = [{ text: `Resume Content:\n\n${resumeText}\n\n${PROMPT}` }];
} else {
  const base64 = await toBase64(file);
  messageParts = [
    { inline_data: { mime_type: mimeType, data: base64 } },
    { text: PROMPT },
  ];
}

 const response = await fetchWithRetry(
  aiconfig?.[0]?.baseurl,
  {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      contents: [
        {
        parts: messageParts,
        },
      ],
    }),
  },
  3,
  3000
);
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err?.error?.message || "API Failed");
      }
      const data = await response.json();
      const rawText =
        data?.candidates?.[0]?.content?.parts?.[0]?.text || "{}";
console.log("Raw response from API:", rawText);
      const parsed = JSON.parse(cleanJSON(rawText));
console.log(parsed,"parsed")


      const endTime = Date.now();
            const totalSeconds = (
              (endTime - startTime) / 1000
            ).toFixed(2);
            if(!parsed?.error){
              setresumedataai(parsed)
            }
            console.log(data,"data")
             const usage = data?.usageMetadata;
             console.log(usage,"usage")

if (usage) {
  inputTokens = usage.promptTokenCount ?? 0;
  outputTokens = usage.candidatesTokenCount ?? 0;
  imageTokens = usage.promptTokensDetails?.[1]?.tokenCount ?? 0
}
  
await Logsubmit(inputTokens,outputTokens,totalSeconds,JSON.stringify(parsed, null, 2),imageTokens)
if(parsed?.error){
  showConfirm({
    content:parsed?.error,
    hideCancel:true
  })
  setResumeFile(null)
  
  return;
}
const personal=parsed?.personal
const contact = parsed?.contact
const application = parsed?.application
const education = parsed?.education
const skills = parsed?.skills
const professional=parsed?.professional




const qualificationId = findMasterId(
  formData.qualification,
  education?.highest_qualification,
  ["Qualification", "$Qualification#Qualification", "label"]
);


const experienceId = findExperienceId(
  formData.experience,
  professional?.total_experience
);

     form.setFieldsValue({
  fullname: personal.full_name || "",
  dob: personal?.date_of_birth ? dayjs(personal?.date_of_birth) : null,
  gender: personal?.gender,
  nationality: personal?.nationality,
  currentaddress: personal?.current_address,
  email: contact?.email_id,
  countrycodecontact: contact?.country_code || "+91",
  contactnumber: contact?.contact_number,
  linkedin: contact?.linkedin_profile,
  currentcompany: professional?.current_last_company,
  totalexperience: professional?.total_experience || null,
  qualification: qualificationId || education?.highest_qualification,
  stream: education?.specialisation_stream,
  institute: education?.institute_university,
  passingyear: education?.passing_year,
  StageID: 2,
});

     const mappedSkills = (parsed?.skills || []).map((skill) => {
  const found = formData.skillname &&  formData?.skillname?.find(
    (x) =>
      normalize(x.SkillName) === normalize(skill) ||
      normalize(x.label) === normalize(skill) ||
      normalize(x["$SkillName#SkillName"]) === normalize(skill)
  );

  return {
    recid: found?.recid || null,
    label: skill,
  };
});

if(setSkills){
  setSkills?.(mappedSkills);
}
setresumerequired(false)
setresumerequired(false)
      message.success("Resume parsed successfully");
    } catch (err) {
      console.log(err);
      message.error(err.message || "Resume parsing failed");
    } finally {
      setLoading(false);
        setResumeUploading(false);
        
    }
  };
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const fetchWithRetry = async (url, options, retries = 3, delay = 3000) => {
  let lastError;

  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const response = await fetch(url, options);

      if (response.ok) return response;

      const errData = await response.json().catch(() => ({}));
      const msg = errData?.error?.message || "API Failed";

      const shouldRetry =
        response.status === 503 ||
        response.status === 429 ||
        msg.toLowerCase().includes("overloaded") ||
        msg.toLowerCase().includes("high demand") ||
        msg.toLowerCase().includes("service unavailable");

      if (!shouldRetry || attempt === retries) {
        throw new Error(msg);
      }

      await sleep(delay);
    } catch (err) {
      lastError = err;

      if (attempt === retries) {
        throw lastError;
      }

      await sleep(delay);
    }
  }
}


  return (
    <Form.Item
      label={
        <>
          Resume / CV
          <span style={{ color: "#ff0000a2", marginLeft: "6px" }}>
            *
          </span>
        </>
      }
      required
      validateStatus={!resumeFile ? "error" : ""}
      help={
        isresume && !resumeFile
          ? "Please upload your resume"
          : ""
      }
    >
      <Upload
        accept=".pdf,.doc,.docx,image/*"
        maxCount={1}
        beforeUpload={async (file) => {
          const isLt5MB = file.size / 1024 / 1024 < 5;

          if (!isLt5MB) {
            message.error("File size must be less than 5 MB");
            return Upload.LIST_IGNORE;
          }
          setResumeFile(file);
          await extractResumeData(file);
          return false;
        }}
        onRemove={() => setResumeFile(null)}
        fileList={
          resumeFile
            ? [
                {
                  uid: "-1",
                  name: resumeFile.name,
                  status: "done",
                },
              ]
            : []
        }
      >
        <Button
          icon={loading ? <LoadingOutlined /> : <UploadOutlined />}
          loading={loading}
          size="large"
        >
          Click to Upload Resume
        </Button>
      </Upload>
    </Form.Item>
  );
}